import React from "react";

const GOLD = "#ffc000";
const PRIMARY = "#000c66";

export const PageHero = ({ eyebrow, title, highlight, subtitle, extra }) => (
  <section
    style={{
      background: `linear-gradient(150deg, ${PRIMARY} 0%, #000a4d 100%)`,
      position: "relative",
      overflow: "hidden",
      minHeight: 260,
    }}
  >
    {/* Faint cross watermark */}
    <svg
      style={{
        position: "absolute",
        right: -40,
        top: "50%",
        transform: "translateY(-50%)",
        opacity: 0.05,
        pointerEvents: "none",
      }}
      width={360}
      height={360}
      viewBox="0 0 200 200"
      fill="#fff"
    >
      <rect x="88" y="10" width="24" height="180" rx="4" />
      <rect x="10" y="68" width="180" height="24" rx="4" />
      <circle cx="100" cy="100" r="94" stroke="#fff" strokeWidth="1" fill="none" strokeDasharray="6 6" />
    </svg>

    {/* Gold corner brackets */}
    {[
      { top: 16, left: 16, borderTop: `2px solid ${GOLD}`, borderLeft: `2px solid ${GOLD}` },
      { top: 16, right: 16, borderTop: `2px solid ${GOLD}`, borderRight: `2px solid ${GOLD}` },
      { bottom: 16, left: 16, borderBottom: `2px solid ${GOLD}`, borderLeft: `2px solid ${GOLD}` },
      { bottom: 16, right: 16, borderBottom: `2px solid ${GOLD}`, borderRight: `2px solid ${GOLD}` },
    ].map((s, i) => (
      <span key={i} style={{ position: "absolute", width: 20, height: 20, zIndex: 2, ...s }} />
    ))}

    {/* Content */}
    <div
      className="relative z-10 flex flex-col items-center justify-center text-center px-4 py-14 md:py-20"
      style={{ minHeight: 260 }}
    >
      {/* Eyebrow */}
      {eyebrow && (
        <div className="flex items-center gap-3 mb-4">
          <div className="h-px w-8" style={{ background: `${GOLD}88` }} />
          <p className="font-abel uppercase tracking-[0.4em] text-xs" style={{ color: GOLD }}>
            {eyebrow}
          </p>
          <div className="h-px w-8" style={{ background: `${GOLD}88` }} />
        </div>
      )}

      {/* Title */}
      <h1
        className="font-aref font-bold text-white leading-tight"
        style={{ fontSize: "clamp(2rem, 5vw, 3.5rem)" }}
      >
        {highlight ? (
          <>
            {title} <span style={{ color: GOLD }}>{highlight}</span>
          </>
        ) : (
          title
        )}
      </h1>

      {/* Gold cross divider */}
      <div className="my-5 flex items-center gap-3" style={{ width: 180 }}>
        <div className="flex-1 h-px" style={{ background: `${GOLD}55` }} />
        <svg viewBox="0 0 24 24" width={11} height={11} fill={GOLD}>
          <path d="M9 0h6v7h9v6h-9v11H9V13H0V7h9z" />
        </svg>
        <div className="flex-1 h-px" style={{ background: `${GOLD}55` }} />
      </div>

      {/* Subtitle */}
      {subtitle && (
        <p
          className="font-abel text-sm md:text-base"
          style={{ color: "rgba(255,255,255,0.6)", maxWidth: 480 }}
        >
          {subtitle}
        </p>
      )}

      {/* Extra slot */}
      {extra && <div className="mt-6">{extra}</div>}
    </div>
  </section>
);
